import type React from "react";
import { useTranslation } from "react-i18next";
import type { BriefDetails } from "src/model/model";

interface AssetDetailsProps {
  data: BriefDetails | Record<string, unknown>;
  mode: "plan" | "recap";
}

const ns = "pages.chat.interactionDetails";

/** Renderer for PDF, Video 2D, Audio, Tuto — asset-description types */
const AssetDetails: React.FC<AssetDetailsProps> = ({ data, mode }) => {
  const { t } = useTranslation();
  if (!data) return null;

  if (mode === "plan") {
    const bd = data as BriefDetails;
    if (!bd.expectedAssetDescription) return null;
    return (
      <div className="text-[11px] text-gray-700">
        <span className="font-medium text-gray-500">{t(`${ns}.assetDescription`)} : </span>
        {bd.expectedAssetDescription}
      </div>
    );
  }

  // Recap mode: asset types don't have much generated text content
  const d = data as Record<string, unknown>;
  if (d.text) {
    return (
      <div className="text-[11px] text-gray-700 whitespace-pre-wrap bg-gray-50 rounded p-2">
        {String(d.text)}
      </div>
    );
  }
  return null;
};

export default AssetDetails;
